import { useState } from "react";
const useRealTimeState = (props)=>{
    const { isRealtime } = props;
    const [startRealTime, setStartRealTime] = useState(false);
    return {
        startRealTime,
        setStartRealTime,
        isRealtime
    };
};
export { useRealTimeState };
